import { IColors } from 'affiny-ui/src/theme/IColors';
import React from 'react';
import { Box, BoxProps } from '../primitives';

export const icons = [
  'camera',
  'add',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'arrow-down',
  'arrow-plus',
  'arrow-heart',
  'arrow-white',
  'arrow-double',
  'bachelors-heart',
  'bell',
  'bubble',
  'bubble-thin',
  'camera-pc',
  'castle',
  'check',
  'check-rounded',
  'check-confirmation',
  'checkbox-checked',
  'checkbox-empty',
  'checklist',
  'chevron-lg-right',
  'cigarette',
  'coffee',
  'compatibilityReportGrid',
  'criterias-medium',
  'cross-thin',
  'cross',
  'crossedEye',
  'desktop-search',
  'edit',
  'email',
  'error',
  'exit',
  'face',
  'facebook-icon',
  'femme',
  'firework',
  'glasses',
  'glowing-heart',
  'group',
  'handshake',
  'happy-heart',
  'heart-full',
  'heart-in',
  'heart',
  'help',
  'home',
  'icon-check',
  'icon-compat-minus',
  'icon-compat-plus',
  'list',
  'lock',
  'lock-closed',
  'lockgrey',
  'logo-cartouche',
  'logo-affiny',
  'logo-meeticaffinity',
  'logo-partner-de',
  'logo-partner-chg',
  'logo-matchaffinity',
  'logo-lexamore',
  'mail',
  'map-pin',
  'mask',
  'measure',
  'men',
  'message-bubble-blink',
  'movie',
  'music',
  'nav-back-arrow',
  'navbar-affiny-color',
  'no-chat',
  'painting',
  'paper-board',
  'padlock',
  'plus',
  'profile-check',
  'profile',
  'profile-alt',
  'right-arrow',
  'search',
  'settings',
  'submenu',
  'tab-profile',
  'target',
  'test-personnalite',
  'unsubscribe',
  'upload-photo',
  'beach-umbrella',
  'visits',
  'welcome',
  'zen',
  'send-message-arrow',
  'who-can-see',
] as const;

export type IconName = typeof icons[number];

export type IconProps = Omit<BoxProps, 'size' | 'color'> & {
  name: IconName;
  size?: string | number | string[] | number[];
  color?: string | string[] | IColors;
  className?: string;
};

export const Icon = ({
  name,
  size = 'inherit',
  color = 'inherit',
  className = '',
  ...rest
}: IconProps) => (
  <Box
    className={['icon', `icon-${name}`, className].join(' ')}
    fontSize={size}
    color={color as any}
    {...rest}
  />
);
